import { render, staticRenderFns } from "./UnassignedTickets.vue?vue&type=template&id=b5943848&"
import script from "./UnassignedTickets.vue?vue&type=script&lang=js&"
export * from "./UnassignedTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports